import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('HotelRoomService', HotelRoomService);

  HotelRoomService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'TranslationModalService',
    'HotelRoomModalService',
    'WindowModalService',
    'ModalWindowConfirmService',
    'UploadService',
  ];

  function HotelRoomService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    TranslationModalService,
    HotelRoomModalService,
    WindowModalService,
    ModalWindowConfirmService,
    UploadService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'hotels';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getHotelRooms: getHotelRooms,
      getHotelRoom: getHotelRoom,
      saveHotelRoom: saveHotelRoom,
      openLogo: openLogo,
      updateLogo: updateLogo,
      openHotelRoomTranslations: openHotelRoomTranslations,
      openHotelRoomDetailModal: openHotelRoomDetailModal,
      deleteHotelRoom: deleteHotelRoom,
      changeHotelRoomStatus: changeHotelRoomStatus,
      openHotelRoomInfoModal: openHotelRoomInfoModal,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getHotelRooms(hotelId, filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      var url = apiUrl + '/' + hotelId + '/hotel_rooms';

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getHotelRoom(roomId, hotelId, language, translate) {
      var params = { lang: null, get: null };

      if (language) {
        params.lang = language;
      }

      if (translate) {
        params.get = 'translate';
      }

      var url = apiUrl + '/' + hotelId + '/hotel_rooms/' + roomId;

      return RestResource.request(
        'get',
        url,
        params,
        function (response) {
          response.data.logoUrl = utils.cleanItemCache(response.data, 'logo');
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveHotelRoom(item, hotelId, language, cropedImage) {
      var method;
      var url = apiUrl + '/' + hotelId + '/hotel_rooms';
      if (!item.id) {
        // create
        method = 'post';
      } else {
        method = 'put';
        url = url + '/' + item.id;
      }

      var lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;
      url = url + '?lang=' + lang;

      return UploadService.uploadFile(
        method,
        url,
        'hotel_room',
        item,
        cropedImage,
        function () {},
        function (response) {
          var msg = item.id ? 'HOTEL_ROOM_MODIFIED' : 'HOTEL_ROOM_ADDED';
          utils._successMsg($translate(msg));

          if (!item.id) {
            // Create
            var itemAddedFlashMsg =
              $translate('HOTEL_ROOM_ADDED_MSG') + ' ' + $translate('REMEMBER_ADD_TRANSLATIONS');
            utils._setFlashMessage(itemAddedFlashMsg);
          }

          return response;
        },
        function () {}
      );
    }

    function openHotelRoomTranslations(item, hotelId, additionalLanguages) {
      var template = './app/ajs/hotel-rooms/modals/hotel-room-detail-translation.html';

      var modalParams = {
        title: item.name,
        item: item,
        additionalLanguages: additionalLanguages,
      };

      var initializeCallback = function (itemId, language) {
        return getHotelRoom(itemId, hotelId, language, 'translate').then(function (data) {
          return data;
        });
      };

      var confirmCallback = function (item, language) {
        return saveHotelRoom(item, hotelId, language, '').then(function (data) {
          if (!data.status) {
            return data.response;
          }

          return false;
        });
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function openLogo(item, saveLogoCallBack) {
      utils.openLogo(item, saveLogoCallBack);
    }

    // Update logo after crop
    function updateLogo(item, hotelId, cropedImage, successCallback) {
      var url =
        apiUrl +
        '/' +
        hotelId +
        '/hotel_rooms/' +
        item.id +
        '?lang=' +
        config.DEFAULT_CONTENT_LANGUAGE;

      utils.updateLogo(url, 'hotel_room', item, cropedImage, successCallback);
    }

    function deleteHotelRoom(item, hotelId, successCallback) {
      let url = apiUrl + '/' + hotelId + '/hotel_rooms/' + item.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let modalParams = {
            title: 'DELETE_HOTEL_ROOM',
            itemName: item.name,
            body: 'DELETE_HOTEL_ROOM_WARNING',
            reason: 'DELETE_ITEM_REASON',
            mode: 'danger',
          };

          let confirmCallback = function (reasonStatus) {
            return RestResource.request(
              'delete',
              url,
              { reason_status: reasonStatus },
              function (response) {
                utils._successMsg($translate('HOTEL_ROOM_DELETED'));

                response.data.hotel_rooms = utils.cleanItemsCache(
                  response.data.hotel_rooms,
                  'logo'
                );

                return successCallback(response.data);
              },
              function (response) {
                utils.openModalError(response.data.error);
              }
            );
          };

          ModalWindowConfirmService.open(modalParams, confirmCallback);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeHotelRoomStatus(item, hotelId) {
      let url = apiUrl + '/' + hotelId + '/hotel_rooms/' + item.id + '?set_status=true';

      let newStatus = item.status === config.ACTIVE ? config.INACTIVE : config.ACTIVE;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          utils.changeItemStatus(url, item);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function openHotelRoomDetailModal(
      item,
      mode,
      hotel,
      defaultLanguage,
      additionalLanguages,
      successCallback
    ) {
      var templateUrl = './app/ajs/hotel-rooms/modals/hotel-room-detail-modal.html';

      var originalItem = angular.copy(item);

      var modalParams = {
        title: 'HOTEL_ROOM_DETAILS',
        item: originalItem,
        mode: mode,
        parentOptions: hotel,
        defaultLanguage: defaultLanguage,
        additionalLanguages: additionalLanguages,
        preventModalClose: true,
        closeOnSave: false,
      };

      // if (!item.id){
      modalParams.closeOnSave = false; // Do not close modal after create
      // }

      // onSavedItem in modal service
      var confirmCallback = function (room) {
        if (item.id) {
          // edit
          if (!room.logoUpdated) {
            item.name = room.name;
            item.ideal_for = room.ideal_for;
            item.description = room.description;
            item.bed_configuration = room.bed_configuration;
            item.url_video = room.url_video;
            item.max_occupancy = room.max_occupancy;
            item.children_allowed = room.children_allowed;
            item.max_children_occupancy = room.max_children_occupancy;
            item.total_bedrooms = room.total_bedrooms;
            item.base_availability = room.base_availability;
            item.size = room.size;
            item.wifi = room.wifi;
            item.not_smoking = room.not_smoking;
            item.room_type_id = room.room_type_id;
            item.room_type = room.room_type;
            item.occupancy_type_id = room.occupancy_type_id;
            item.occupancy_type = room.occupancy_type;
            item.facility_ids = room.facility_ids;
            item.photos = room.photos;
          }

          item.logo = room.logo;
          item.logoUrl = utils.cleanItemCache(room, 'logo');

          return utils.itemListChanged(room.id);
        }

        // create
        item = angular.copy(room);
        utils.itemListChanged(item.id);

        return successCallback(item);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function openHotelRoomInfoModal(parentId, itemId) {
      HotelRoomModalService.openHotelRoomInfo(parentId, itemId);
    }
  }
})();

/*var modalParams = {
                mode:       'danger', 
                title:      'DELETE_HOTEL_ROOM', 
                itemName:    item.name,
                body:       'DELETE_HOTEL_ROOM_WARNING', 
                reason:     'DELETE_ITEM_REASON', 
                confirmButtonLabel: 'CONFIRM_DELETION'
            };

            var url = apiUrl +'/'+ hotelId +'/hotel_rooms/'+ item.id;
            
            var confirmCallback = function (reasonStatus) {
                function success(response) {
                    var msg = $translate('HOTEL_ROOM_DELETED');
                    utils._successMsg(msg);

                    response.data.hotel_rooms = utils.cleanItemsCache(response.data.hotel_rooms, 'logo');

                    return successCallback(response.data);
                }
                function failure(response) {
                    utils._errorMsg(response.data.error);
                }

                return RestResource.request('delete', url, { reason_status: reasonStatus }, success, failure);
            };

            ModalWindowConfirmService.open(modalParams, confirmCallback);*/

// utils.changeItemStatus(apiUrl +'/'+ hotelId +'/hotel_rooms/'+ item.id, item);
